"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildProjectModel = void 0;
var util_1 = require("../organisations/util");
var util_2 = require("../segments/util");
var models_1 = require("./models");
function buildProjectModel(projectJSON) {
    var segments = projectJSON['segments']
        ? projectJSON['segments'].map(function (s) { return (0, util_2.buildSegmentModel)(s); })
        : [];
    var model = new models_1.ProjectModel(projectJSON.id, projectJSON.name, projectJSON.hide_disabled_flags, (0, util_1.buildOrganizationModel)(projectJSON.organisation));
    model.segments = segments;
    return model;
}
exports.buildProjectModel = buildProjectModel;
